export default __webpack_public_path__ + "static/media/publish_template.f79011b1.png";